import { createFromIconfontCN } from '@ant-design/icons';
import { icon } from '@/assets/icons/iconfont.js'
const IconFont = createFromIconfontCN({ scriptUrl: { icon } });

export default IconFont;